import GetRequest from "../utilities/api/get-request";

class WixCollection {

    /**
    *--------------------------------------------------------------------------
    * Get collections (wix)
    *--------------------------------------------------------------------------
    *
    */

    static async get(filterParameters = {}) {
        const path = '/api/collections/wix';

        return await GetRequest(path, filterParameters);
    }

}

export default WixCollection;